declare global {
  interface Window {
    dataLayer: any;
  }
}
export interface CartAnalyticsInfo {
  currency: string;
  value: number;
  items: Array<ItemAnalyticsInfo>;
}

export interface ItemAnalyticsInfo {
  item_id: string;
  item_name: string;
  item_brand: string;
  item_variant: string;
  price: number;
  quantity: number;
  time_in_cart?: string;
}

export interface OrderAnalyticsInfo {
  transaction_id: string;
  value: number;
  tax: string;
  shipping: string;
  currency: string;
  items: Array<ItemAnalyticsInfo>;
  payment_type?: string;
}

function getTimeInCart(dateAdded?: string) {
  if (!dateAdded) return undefined;

  const totalMinutes = Math.floor((Date.now() - new Date(dateAdded).getTime()) / (1000 * 60));

  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const duration: string[] = [];

  if (days > 0) {
    duration.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  }

  if (hours > 0) {
    duration.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
  }

  if (minutes > 0 || duration.length === 0) {
    duration.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);
  }

  return duration.join(', ');
}

function ProductToItemJSON(item: any) {
  let value: any = item?.cartItem?.priceOption?.unitPrice * item?.cartItem?.priceOption?.quantity;
  value = value.toFixed(2);
  const itemAnalyticsInfo: CartAnalyticsInfo = {
    currency: 'USD',
    value: value,
    items: [
      {
        item_id: `${item?.cartItem?.product?.productId}`,
        item_name: `${item?.cartItem?.product?.title}`,
        item_brand: `${item?.cartItem?.product?.publicationType}`,
        item_variant: `${item?.cartItem?.priceOption?.variantId}`,
        price: item?.cartItem?.priceOption?.unitPrice.toFixed(2),
        quantity: item?.cartItem?.priceOption?.quantity,
      },
    ],
  };
  return itemAnalyticsInfo;
}
function removeCartEvent(item: any) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  const itemAnalyticsInfo = ProductToItemJSON(item);
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: itemAnalyticsInfo,
  });
}

function addCartEvent(object: any) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: object,
  });
}

function checkoutEvent(object: any) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'begin_checkout',
    ecommerce: object,
  });
}

function purchaseEvent(object: any) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: object,
  });
}

function viewCartEvent(object: any) {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: 'view_cart',
    ecommerce: object,
  });
}

export {
  removeCartEvent,
  addCartEvent,
  purchaseEvent,
  checkoutEvent,
  viewCartEvent,
  getTimeInCart,
};
